import { euCountryCodes } from "./euCountryCodes";
import { reverseChargeCountryCodes } from "./reverseChargeCountryCodes";

// Countries where businesses (with VAT/tax ID) can purchase.
// EU member states + AU, CA, SG, CH, US.

export const businessCountryCodes = new Set([
  ...Array.from(euCountryCodes),
  ...Array.from(reverseChargeCountryCodes),
]);
